import React, { useEffect, useState } from "react";
import car from "../../assets/images/car1.png";
import Swal from "sweetalert2";
import {
    Button, Card, CardBody, Col, Form, FormGroup,
    Input, Label, Row, Modal, ModalHeader, ModalBody, ModalFooter,
} from "reactstrap";
import axios from "../api/axios";
import { toast } from "react-toastify";
import Select from "react-select";
import { SERVER_URL } from "../ServerLink";
import moment from "moment";
import { useDispatch } from "react-redux";
import { isLoading } from "../../store/layout/actions";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { MetaTags } from "react-meta-tags";
import BreadcrumbV3 from "../../components/Common/BreadcrumbV3";
import './parking.scss';

const GET_PROPERTYS_LIST = "parking/property-list";
const GET_TENANTS_LIST = "parking/tenants-list";
const GET_PARKING_LIST = "parking/list";
const GET_PARKING_DOWNLOAD = "parking/download";
const POST_PARKING_UPDATE_LOT = "parking/update-parking-lot";
const POST_PARKING_INFO_REFRESH = "parking/info-refresh";
const GET_PARKING_INFO = "parking/parking-info";

const NewParking = () => {
    const location = useLocation();
    const activeProperty = location?.state?.activeProperty;
    const dispatch = useDispatch();
    const history = useHistory();
    const { userData } = JSON.parse(window.localStorage.getItem("authUser"));
    const { id } = useParams();

    const [propertyList, setPropertyList] = useState([]);
    const [selectPropertyName, setSelectPropertyName] = useState("");
    const [tenantsList, setTenantsList] = useState([]);
    const [selectTenants, setSelectTenants] = useState({ _id: "", value: "", label: "" });
    const [parkingList, setParkingList] = useState([]);
    const [propertyID, setPropertyID] = useState("");
    const [floorType, setFloorType] = useState("");
    const [floor, setFloor] = useState(0);
    const [floors, setFloors] = useState([]);
    const [parkingLots, setParkingLots] = useState([]);
    const [parkingInfo, setParkingInfo] = useState([]);
    const [modal, setModal] = useState(false);
    const [isAddAnother, setIsAddAnother] = useState(false);
    const [isNewAddTenant, setIsNewAddTenant] = useState(false);
    const [isReset, setIsReset] = useState(false);
    const [modalData, setModalData] = useState({ parkingLotNo: "", vehicalNo: "", amount: "", effectiveDate: "" });
    const [modalReadData, setModalReadData] = useState({ name: "", email: "", mobile: "" });
    const [formError, setFormError] = useState({ ownerName: "", vehicalNo: "", amount: "", effectiveDate: "" });

    const toggleClose = () => setModal(false);

    const getPropertyList = async () => {
        try {
            const response = await axios.get(`${GET_PROPERTYS_LIST}?role=${userData.role}&id=${userData.id}`);
            const result = response.data.data;
            if (result && result.length > 0 && Array.isArray(result)) {
                const activePropertyMatch = result.find((p) => p._id === activeProperty);
                setPropertyList(result);
                if (activePropertyMatch) {
                    setSelectPropertyName({ id: activePropertyMatch._id, value: activePropertyMatch.title, label: `${activePropertyMatch.title}, ${activePropertyMatch.location}` });
                    setPropertyID(activePropertyMatch._id);
                }
                if (id && activePropertyMatch) await getParkingInfoById(id, result);
            }
        } catch {}
    };

    const getParkingList = async () => {
        try {
            const response = await axios.get(`${GET_PARKING_LIST}?id=${selectPropertyName.id}`);
            const result2 = response.data.data.parking;
            if (result2) {
                const result = response.data.data.parking.parkingData;
                setParkingList(result);
                setFloors(result[0]["floors"]);
                setParkingInfo(response.data.data.parkingInfo);
                if (!id) {
                    setFloorType(result[0]["floorType"]);
                    setFloor(result[0]["floors"][0]["floor"]);
                    getParkingInfo(response.data.data.parkingInfo, result[0]["floorType"], result[0]["floors"][0]["floor"]);
                }
            } else {
                setFloorType(""); setFloor(""); setParkingList([]); setParkingInfo([]); setParkingLots([]);
            }
        } catch {}
    };

    const getParkingUpdatedList = async (_id, _floorType, _floor) => {
        try {
            const response = await axios.get(`${GET_PARKING_LIST}?id=${_id}`);
            const result = response.data.data.parking.parkingData;
            if (result && result.length && Array.isArray(result)) {
                const _result = result.slice();
                setParkingList(_result);
                const floors = _result.find((item) => item.floorType == _floorType);
                setFloors(floors["floors"]);
                getParkingInfo(response.data.data.parkingInfo, _floorType, _floor);
                return response.data.data.parkingInfo;
            }
            return [];
        } catch {}
    };

    const getParkingInfoById = async (_id, _propertyList) => {
        try {
            const res = await axios.get(`${GET_PARKING_INFO}?id=${_id}`);
            if (res?.data?.status == 200) {
                const response = await axios.get(`${GET_PROPERTYS_LIST}?role=${userData.role}&id=${userData.id}`);
                if (response?.data?.status == 201) {
                    const _result = res.data.data;
                    const _property = response.data.data.find((doc) => doc._id == _result.propertyID);
                    setSelectPropertyName({ id: _property._id, value: _property.title, label: `${_property.title}, ${_property.location}` });
                    setPropertyID(_property._id);
                    setFloorType(_result["floorType"]);
                    setFloor(_result["floor"]);
                    const _parkingInfo = await getParkingUpdatedList(_result.propertyID, _result["floorType"], _result["floor"]);
                    setIsReset(true);
                    handleModel(_result["parkingLotNo"], _result.propertyID, getParkingInfo(_parkingInfo, _result["floorType"], _result["floor"]));
                }
            }
        } catch {}
    };

    const getParkingInfo = (data, _floorType, _floor) => {
        const lotsInfo = data.filter((item) => item.floorType == _floorType && item.floor == _floor);
        setParkingLots(lotsInfo);
        return lotsInfo;
    };

    const handleSelectFloortype = (event) => {
        const { value } = event.target;
        const floors = parkingList.slice().find((item) => item.floorType == value);
        setFloorType(floors["floorType"]);
        setFloors(floors["floors"]);
        setFloor(floors["floors"][0]["floor"]);
        getParkingInfo(parkingInfo.slice(), value, floors["floors"][0]["floor"]);
    };

    const handleSelectFloor = (event) => {
        const { value } = event.target;
        const lots = floors.slice().find((item) => item.floor == value);
        setFloor(lots["floor"]);
        getParkingInfo(parkingInfo.slice(), floorType, lots["floor"]);
    };

    const modalDataSetInState = (data) => {
        const { parkingLotNo, _id, suite, firstname, lastname, email, mobile, vehicalNo, effectiveDate, amount } = data;
        setSelectTenants({ _id: _id || "", value: suite || "", label: suite || "" });
        setModalData({
            parkingLotNo,
            vehicalNo: vehicalNo || "",
            amount: amount || "",
            effectiveDate: effectiveDate ? moment(effectiveDate).format("YYYY-MM-DD") : "",
        });
        setModalReadData({
            name: firstname || lastname ? `${firstname || ""} ${lastname || ""}` : "",
            email: email || "",
            mobile: mobile || "",
        });
    };

    const handleModel = async (data, _propertyID, _parkingLots) => {
        setModal(true);
        setIsAddAnother(false);
        setIsNewAddTenant(false);
        const tenantsList = await axios.get(`${GET_TENANTS_LIST}?id=${_propertyID}`);
        let prarkingDetails = { parkingLotNo: data };
        if (tenantsList.data.data.length > 0) {
            setTenantsList(tenantsList.data.data);
            const _data = _parkingLots.find((item) => item.parkingLotNo == data);
            if (_data) {
                setIsAddAnother(true);
                prarkingDetails = { ...prarkingDetails, ..._data.vehicalOwner[0], vehicalNo: _data.vehicalNo, amount: _data.amount, effectiveDate: _data.effectiveDate };
            }
        }
        modalDataSetInState(prarkingDetails);
    };

    const handleModalChange = (event) => {
        const { name, value } = event.target;
        setModalData({ ...modalData, [name]: value });
        setFormError({ ...formError, [name]: "" });
    };

    const isValidation = (formData) => {
        const { ownerName, vehicalNo, effectiveDate, amount } = formData;
        if (!ownerName) { setFormError({ ...formError, ownerName: "Please Select Suite Number" }); return false; }
        if (!vehicalNo) { setFormError({ ...formError, vehicalNo: "Vehicle No. is required!" }); return false; }
        if (!amount) { setFormError({ ...formError, amount: "Amount is required!" }); return false; }
        if (!effectiveDate) { setFormError({ ...formError, effectiveDate: "Effective Date is required!" }); return false; }
        return true;
    };

    const handleUpdate = async () => {
        try {
            if (!isValidation({ ownerName: selectTenants._id, vehicalNo: modalData.vehicalNo, effectiveDate: modalData.effectiveDate, amount: modalData.amount })) return;
            const result = await Swal.fire({
                title: `${isNewAddTenant ? "Add new" : "Update"} parking?`,
                text: "You won't be able to revert this!", icon: "warning",
                showCancelButton: true, confirmButtonColor: "#4361ee", cancelButtonColor: "#d33",
                confirmButtonText: "Yes, proceed!", cancelButtonText: "Cancel",
            });
            if (!result.isConfirmed) return;
            dispatch(isLoading(true));
            await axios.post(POST_PARKING_UPDATE_LOT, {
                propertyID: propertyID, floorType, floor,
                parkingLotNo: modalData.parkingLotNo,
                updateData: { addAnother: isNewAddTenant, vehicalNo: modalData.vehicalNo, amount: modalData.amount, effectiveDate: modalData.effectiveDate, vehicalOwnerId: selectTenants._id },
            });
            setModalData({ parkingLotNo: "", vehicalNo: "", amount: "", effectiveDate: "" });
            await getParkingUpdatedList(propertyID, floorType, floor);
            toggleClose();
            dispatch(isLoading(false));
            toast.success(`Parking lot ${isNewAddTenant ? "added" : "updated"} successfully.`);
            history.goBack();
        } catch {
            toggleClose();
            toast.error("Something went wrong!");
            dispatch(isLoading(false));
        }
    };

    const handleAddAnother = (data) => {
        try { modalDataSetInState({ parkingLotNo: data }); setIsNewAddTenant(true); }
        catch { toggleClose(); toast.error("Something went wrong!"); }
    };

    const handleReset = async () => {
        try {
            const result = await Swal.fire({
                title: "Reset parking?", text: "This action cannot be undone!", icon: "warning",
                showCancelButton: true, confirmButtonColor: "#4361ee", cancelButtonColor: "#d33",
                confirmButtonText: "Yes, reset!", cancelButtonText: "Cancel",
            });
            if (result.isConfirmed) {
                await axios.post(POST_PARKING_UPDATE_LOT, {
                    propertyID, floorType, floor,
                    parkingLotNo: modalData.parkingLotNo,
                    updateData: { vehicalNo: "", effectiveDate: "", amount: "", vehicalOwnerId: null },
                });
                setModalData({ parkingLotNo: "", vehicalNo: "", amount: "", effectiveDate: "" });
                await getParkingUpdatedList(propertyID, floorType, floor);
                toggleClose();
                toast.success("Parking lot reset successfully.");
                history.push("/parking_info");
            }
        } catch { toggleClose(); toast.error("Something went wrong!"); }
    };

    const handleRefresh = async () => {
        try {
            dispatch(isLoading(true));
            setFloorType(""); setFloor(""); setParkingList([]); setParkingInfo([]); setParkingLots([]);
            await axios.get(`${POST_PARKING_INFO_REFRESH}?id=${propertyID}`);
            await getParkingList();
            dispatch(isLoading(false));
        } catch { dispatch(isLoading(false)); }
    };

    useEffect(() => { if (!id && selectPropertyName) getParkingList(); }, [selectPropertyName]);
    useEffect(() => { if (!id) getPropertyList(); }, []);
    useEffect(() => { if (id) getParkingInfoById(id); }, [id]);

    const getPakingSpace = (__floor) => {
        const _floor = floors.slice().find((item) => item.floor == __floor);
        const _parkingLots = parkingLots.slice();
        const carObject = [];
        if (_floor)
            for (let item = _floor.from; item <= _floor.to; item++) {
                const lotNo = _floor.alphabet + item;
                const isOccupied = _parkingLots.find((_item) => _item.parkingLotNo == lotNo)?.vehicalNo;
                carObject.push(
                    <div
                        key={item}
                        onClick={() => handleModel(lotNo, propertyID, _parkingLots)}
                        className={isOccupied ? "edit_parking" : "add_parking"}
                    >
                        <div className="inner_parking_sec">
                            <span className="parkingNo">{lotNo}</span>
                            <div className="parkingIcn"><img src={car} alt="" /></div>
                        </div>
                    </div>
                );
            }
        return carObject;
    };

    return (
        <div className="page-content">
            <div className="parking_page">
                <MetaTags><title>Rentdigicare | Parking</title></MetaTags>
                <div className="container-fluid">
                    <BreadcrumbV3
                        title="Parking"
                        breadcrumbItems={[
                            { item: "Home", link: "/dashboard" },
                            { item: "Parking", link: "/parking_info" },
                        ]}
                    />
                    <Card>
                        <CardBody>
                            <Row className="mb-3 align-items-center">
                                <Col md={12} className="text-end d-flex gap-2 justify-content-end">
                                    <Button color="primary" disabled={!parkingList.length} onClick={handleRefresh}>
                                        <i className="mdi mdi-refresh me-1" /> Refresh
                                    </Button>
                                    <a
                                        className={parkingList.length ? "" : "isaDisable"}
                                        href={`${SERVER_URL}/${GET_PARKING_DOWNLOAD}?id=${propertyID}&name=${selectPropertyName.value}`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <span className="btn btn-primary">
                                            <i className="mdi mdi-export me-1" /> Export
                                        </span>
                                    </a>
                                </Col>
                            </Row>

                            <div className="parkingTop_sec">
                                <Form>
                                    <Row>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label>Property Name</Label>
                                                <Select
                                                    value={selectPropertyName}
                                                    options={propertyList?.map((item) => ({
                                                        id: item._id, value: item.title,
                                                        label: `${item.title}, ${item.location}`,
                                                    }))}
                                                    placeholder="Search by name…"
                                                    onChange={(event) => { setSelectPropertyName(event); setPropertyID(event.id); }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        {parkingList.length > 0 && (
                                            <>
                                                <Col md={4}>
                                                    <FormGroup>
                                                        <Label>Parking Type</Label>
                                                        <Input type="select" value={floorType} onChange={handleSelectFloortype}>
                                                            {parkingList.map((item, index) =>
                                                                item.isActive && <option key={index} value={item.floorType}>{item.floorType}</option>
                                                            )}
                                                        </Input>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={4}>
                                                    <FormGroup>
                                                        <Label>Parking Floor</Label>
                                                        <Input type="select" value={floor} onChange={handleSelectFloor}>
                                                            {floors.map((item, index) =>
                                                                item.isActive && <option key={index} value={item.floor}>{item.floor}</option>
                                                            )}
                                                        </Input>
                                                    </FormGroup>
                                                </Col>
                                            </>
                                        )}
                                    </Row>
                                </Form>
                            </div>

                            {parkingList.length > 0 ? (
                                <div className="parkingFiling_sec">{floors && getPakingSpace(floor)}</div>
                            ) : (
                                <div className="text-center py-5 text-muted">
                                    <i className="mdi mdi-parking" style={{ fontSize: '2.5rem', display: 'block', marginBottom: 8 }} />
                                    No Parking Found
                                </div>
                            )}
                        </CardBody>
                    </Card>
                </div>
            </div>

            {modal && (
                <Modal isOpen={modal} toggle={toggleClose} className="parking-modal">
                    <ModalHeader toggle={toggleClose}>Parking — {modalData.parkingLotNo}</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md={12} className="mt-2">
                                <FormGroup>
                                    <Label>Parking No</Label>
                                    <Input readOnly name="parkingLotNo" type="text" value={modalData.parkingLotNo} />
                                </FormGroup>
                            </Col>
                            <Col md={12} className="mt-2">
                                <FormGroup>
                                    <Label>Suite Number *</Label>
                                    <Select
                                        value={selectTenants}
                                        options={tenantsList?.map((item) => ({ _id: item._id, value: item.suite || "", label: item.suite || "" }))}
                                        placeholder="Search by suite…"
                                        onChange={(event) => {
                                            setSelectTenants(event);
                                            const { firstname, lastname, email, mobile } = tenantsList.find((doc) => doc._id == event._id);
                                            setModalReadData({
                                                name: firstname || lastname ? `${firstname || ""} ${lastname || ""}` : "",
                                                email: email || "", mobile: mobile || "",
                                            });
                                            setFormError({ ...formError, ownerName: "" });
                                        }}
                                    />
                                    {formError["ownerName"] && <Label style={{ color: "red", fontSize: '0.8rem' }}>{formError["ownerName"]}</Label>}
                                </FormGroup>
                            </Col>
                            {[
                                { label: "Name", name: "name", value: modalReadData.name },
                                { label: "Email", name: "email", value: modalReadData.email },
                                { label: "Mobile No.", name: "mobile", value: modalReadData.mobile },
                            ].map(({ label, name, value }) => (
                                <Col key={name} md={12} className="mt-2">
                                    <FormGroup>
                                        <Label>{label}</Label>
                                        <Input readOnly name={name} type="text" value={value} />
                                    </FormGroup>
                                </Col>
                            ))}
                            <Col md={12} className="mt-2">
                                <FormGroup>
                                    <Label>Vehicle No *</Label>
                                    <Input name="vehicalNo" placeholder="Enter Vehicle No" type="text" value={modalData.vehicalNo} onChange={handleModalChange} />
                                    {formError["vehicalNo"] && <Label style={{ color: "red", fontSize: '0.8rem' }}>{formError["vehicalNo"]}</Label>}
                                </FormGroup>
                            </Col>
                            <Col md={12} className="mt-2">
                                <FormGroup>
                                    <Label>Amount *</Label>
                                    <Input name="amount" type="number" value={modalData.amount} onChange={handleModalChange} />
                                    {formError["amount"] && <Label style={{ color: "red", fontSize: '0.8rem' }}>{formError["amount"]}</Label>}
                                </FormGroup>
                            </Col>
                            <Col md={12} className="mt-2">
                                <FormGroup>
                                    <Label>Effective Date *</Label>
                                    <Input name="effectiveDate" type="date" value={modalData.effectiveDate} onChange={handleModalChange} />
                                    {formError["effectiveDate"] && <Label style={{ color: "red", fontSize: '0.8rem' }}>{formError["effectiveDate"]}</Label>}
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        {isReset && (
                            <Button disabled={!tenantsList.length} color="success" onClick={handleReset}>Reset</Button>
                        )}
                        {isAddAnother && (
                            <Button disabled={!tenantsList.length} color="primary" onClick={() => isNewAddTenant ? handleUpdate() : handleAddAnother(modalData.parkingLotNo)}>
                                Add Another
                            </Button>
                        )}
                        {!isNewAddTenant && (
                            <Button disabled={!tenantsList.length} color="primary" onClick={handleUpdate}>Update</Button>
                        )}
                        <Button color="danger" onClick={toggleClose}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            )}
        </div>
    );
};

export default NewParking;